<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    西丽湖站<br>
站点介绍<br>
西丽湖站位于丽水路下。北侧是深圳野生动物园与西丽湖度假村，东侧为深圳大学城清华园区一角，西南侧位于住宅集中区域（西湖林语，丽湖花园，德意名居，平丽花园），南端是丽山路贯通与5号线大学城站的一条道路，路经平山村，桃源街道办，桑泰物业片区。西丽湖站装修设计以绿色为主，吊顶绿色光圈LED柔和的灯光配置特色文化墙，给人清新和谐的感觉。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	--	--	7号线	3分35秒	5分55秒<br>
太安	06:15	23:00	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	--	--	7号线	4分钟	5分55秒<br>
太安	06:20	23:00	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	--	--	7号线	4分钟	5分55秒<br>
太安	06:20	00:00	7号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
丽水路北侧<br><br>
B出入口:<br>
西丽湖路、深圳野生动物园、西丽湖度假村、丽湖花园、西丽山庄、紫荆山庄、平丽花园、德意名居、丽水路南侧、丽山路、西湖林语、学城绿园、硅谷公寓、桑泰丹华园<br>
（原C出入口地址全部转到B出入口，车站没有C出入口）D出入口:
丽水路南侧、西湖林语、学城绿园、清华大学深圳国际研究生院、深圳大学城（北区）<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 丽山路北<br>
36路,49路,M369路,M460路<br><br>
B出入口:<br>
公交站名： 动物园<br>
101路、104路、226路、36路、49路、66路、B736路、B796路、B797路、M460路、M492路<br><br>
B出入口:<br>
公交站名： 西丽动物园总站（公交站）<br>
104路、226路、36路、B796路、M203路<br><br>
B出入口:<br>
公交站名： 西丽湖地铁站<br>
B736路、M369路<br><br>
D出入口:<br>
公交站名： 西丽湖地铁站<br>
B736路、M369路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>